export enum EVerificationMethod {
  PHONE = 'phone',
  EMAIL = 'email',
}
